import Vue from 'vue'
import VueRouter, { Route, NavigationGuardNext, RouteConfig } from 'vue-router'
import store from '../store'

import authRoutes from '../domains/auth/auth.routes'
import dashboardRoutes from '../domains/dashboard/dashboard.routes'
import profileRoutes from '../domains/profile/profile.routes'
import translationServiceRoutes from '../domains/translation-services/translation-services.routes'
import relationshipRoutes from '../domains/relationships/relationships.routes'
import jobRoutes from '../domains/jobs/jobs.routes'
import activityRoutes from '../domains/activities/activities.routes'
import customerInvoiceRoutes from '../domains/customer-invoices/customer-invoices.routes'
import disputeRoutes from '../domains/disputes/disputes.routes'
import customerRoutes from '../domains/customers/customers.routes'
import reportingRoutes from '../domains/reporting/reporting.routes'
import providerRoutes from '../domains/providers/providers.routes'
import disbursementsRoutes from '../domains/disbursements/disbursements.routes'
import transactionsRoutes from '../domains/transactions/transactions.routes'
import userRoutes from '../domains/users/users.routes'
import invoiceRoutes from '../domains/invoices/invoices.routes'
import webhookRoutes from '../domains/webhooks/webhooks.routes'
import payments from '../domains/payments/payments.routes'
import distributorsRoutes from '../domains/distributors/distributors.routes'
import pricingRoutes from '../domains/pricing/pricing.routes'
import extendedPoolConfigRoutes from '../domains/extended-pool-config/extended-pool-config.routes'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    meta: {
      public: true
    },
    path: '/healthcheck',
    name: 'healthcheck',
    component: () => import(/* webpackChunkName: "healthcheck" */ '../domains/global/pages/HealthcheckPage.vue')
  },
  ...authRoutes,
  ...dashboardRoutes,
  ...profileRoutes,
  ...translationServiceRoutes,
  ...relationshipRoutes,
  ...jobRoutes,
  ...activityRoutes,
  ...customerInvoiceRoutes,
  ...disputeRoutes,
  ...customerRoutes,
  ...reportingRoutes,
  ...providerRoutes,
  ...userRoutes,
  ...disbursementsRoutes,
  ...transactionsRoutes,
  ...invoiceRoutes,
  ...webhookRoutes,
  ...payments,
  ...distributorsRoutes,
  ...pricingRoutes,
  ...extendedPoolConfigRoutes,
  {
    path: '*',
    name: 'not-found',
    component: () => import(/* webpackChunkName: "errors" */ '../domains/global/components/SimpleError.vue'),
    props: {
      error: 'not-found',
      notFoundTitle: 'Page Not Found',
      notFoundMessage: 'The page you are looking for cannot be found.'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

async function authGuard (to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  if (to.meta?.public === true) {
    return next()
  }

  if (!store.state.auth?.isAuthenticated) {
    try {
      await store.dispatch('auth/refresh')
    } catch (error) {
      await store.dispatch('saveError', null)
      if (to.path) {
        return next({ name: 'login', query: { ...to.query, redirect: to.path } })
      } else {
        return next({ name: 'login' })
      }
    }
  }

  if (!store.state.auth?.isAuthenticated) {
    return next({ name: 'login', query: { ...to.query, redirect: to.path } })
  }

  if (to.name !== 'login' && !store.state.auth?.isTwoFactorAuthenticated) {
    return next({ name: 'login', query: { ...to.query, redirect: to.path } })
  }

  return next()
}

router.beforeEach(authGuard)

export default router
